import React from "react";
import { Image, H4 } from "../../AbstractElements";
import { Sidebarmenutext } from "../../Shared/Constants";

const Sidebarimgsection = () => {
  return <div className="sidebar-img-section"></div>;
};
export default Sidebarimgsection;
